import { GridColDef } from '@mui/x-data-grid-premium'

const category: GridColDef = {
	field: 'productClass.categoryName',
	headerName: 'Category',
	flex: 1,
	sortable: false,
	valueGetter: ( _value, row ) => row.productClass?.categoryName ?? '',
}

export default category